























import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import HoverDescription from '@/components/atoms/HoverDescription.vue';
import { ID } from '@/types/type';
import { REL } from '@/utils/consts';

@Component({ components: { HoverDescription } })
export default class LinkButton extends Vue {
  @Prop()
  private id!: ID;

  @Prop()
  private title!: string;

  @Prop()
  private url!: string;

  private getTitle(): string {
    return this.title.length > 0 ? this.title : this.url;
  }

  @Emit('button-link-opened')
  private moveLink(): ID {
    window.open(this.url, '_blank', REL);
    return this.id;
  }
}
